import * as React from 'react';

function SvgSpringMinus9(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.076 24.663v6.98l-10.052 6.552 20.103 13.106-20.103 13.105 20.103 13.106-20.103 13.105 20.103 13.106-20.103 13.105 20.103 13.105-20.103 13.106 20.103 13.105-20.103 13.106 20.103 13.105-10.051 6.553v6.98"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M20.576 242.4v2.279l-17.318 3.066 20.104 3.558-20.104 3.56 20.104 3.559-20.104 3.558 20.104 3.558-20.104 3.558 20.105 3.56-20.105 3.558 20.104 3.559-20.104 3.558 20.104 3.558-2.786.494v4.853h5v-2.281l17.319-3.064-20.106-3.56 20.106-3.558-20.104-3.559 20.104-3.558-20.104-3.558 20.104-3.56-20.104-3.559 20.104-3.558-20.104-3.558 20.104-3.56-20.106-3.558 2.787-.493V242.4h-5z"
        fill={props.springcolor}
      />
      <path
        d="M34.609 0h-23v23h23V0zM34.609 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringMinus9;
